export default "__VITE_ASSET__81215284__"